import { apiHelper, apiUnauthenticatedHelper } from "./core"
const adminServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL
const resourceServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL

const addNewReferralDoctor = (referralDoctorInfo: any): Promise<any> => {
  return apiHelper
    .post(`${adminServiceBaseUrl}/referrals`, referralDoctorInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const addNewServices = (referralDoctorInfo: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/services`, referralDoctorInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const addMasterNewServices = (
  data1: any,
  data2: any,
  data3: any
): Promise<any> => {
  var data = {
    name: data1,
    appointmentType: data2,
    defaultPrice: data3,
  }
  console.log(data, "datas")
  return apiHelper
    .post(`${masterServiceBaseUrl}/services`, data)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const addNewMasterServices = (values: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/services`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateMasterServices = (id: any, values: any): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/services/${id}`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//copy services
const copyServices = (fromCenterId: any, toCenterId: any): Promise<any> => {
  return apiHelper
    .post(
      `${masterServiceBaseUrl}/services/copy?fromCenterId=${fromCenterId}&toCenterId=${toCenterId}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateNewServices = (id: any, referralDoctorInfo: any): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/services/${id}`, referralDoctorInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//get center detail
const getCenterDetails = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/centers`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
// get minimal center for register

const getMinimalRegisterCenter = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/centers/public`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//get services that are not there in particular center
const getServicesNotInCenter = (centerId: any): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/services/not-in-center?centerId=${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//get services details that are in service Id
const getServiceDetailByServiceId = (serviceId: any): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/services/${serviceId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const deleteConsultantDetail = (id: string): Promise<any> => {
  return apiHelper
    .delete(`${adminServiceBaseUrl}/referrals/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const deleteConsultantServiceDetail = (id: string): Promise<any> => {
  return apiHelper
    .delete(`${masterServiceBaseUrl}/services/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllConsultantReferralDetails = (centerId: any): Promise<any> => {
  let url = "referrals"
  if (centerId) {
    url += `?centerId=${centerId}`
  }
  return apiHelper
    .get(`${adminServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllConsultantServicesDetails = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/services`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllMasterServicesDetails = (query: any): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/${query}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getServicesBasedOnCenterId = (centerId: any): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/services/minimal?centerId=${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const getConsultantReferralDetailsById = (id: string): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/referrals/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getRateCardByServiceId = (centerId: string, id: string): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/rates/center?serviceId=${id}&centerId=${centerId}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getConsultantServiceDetailsById = (id: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/services/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const updateContactReferrals = (
  id: any,
  updateContactReferralsReq: any
): Promise<any> => {
  return apiHelper
    .put(`${adminServiceBaseUrl}/referrals/${id}`, updateContactReferralsReq)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const updateServices = (
  id: any,
  updateContactReferralsReq: any
): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/services`, updateContactReferralsReq)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllManageStaffDetailsByCenterId = (id: any): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/staff?centerId=${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllManageStaffDetails = (): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/staff`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllManageStaffDetailsByCenter = (centerId: any): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/staff/consultant/other-center/${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const addManageStaff = (id: any, addManageStaffReq: any): Promise<any> => {
  return apiHelper
    .post(`${adminServiceBaseUrl}/staff`, addManageStaffReq)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const updateManageStaff = (
  id: any,
  updateManageStaffReq: any
): Promise<any> => {
  delete updateManageStaffReq["id"]
  return apiHelper
    .put(`${adminServiceBaseUrl}/staff/${id}`, updateManageStaffReq)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const getManageStaffDetailsById = (id: string): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/staff/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllStaffRoles = (): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/roles/staff-types`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const deleteManageStaff = (id: string): Promise<any> => {
  return apiHelper
    .delete(`${adminServiceBaseUrl}/staff/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const addNewBed = (bedManagementInfo: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/room`, bedManagementInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateBedManagement = (
  id: any,
  updateBedManagementReq: any
): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/room/${id}`, updateBedManagementReq)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const getBedManagementDetailsById = (id: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/room/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const deleteBedDetail = (id: string): Promise<any> => {
  return apiHelper
    .delete(`${masterServiceBaseUrl}/room/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getDuplicatePatients = (url: any): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/patients${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const getDuplicatePatientView = (id: any): Promise<any> => {
  return apiHelper
    .get(`${adminServiceBaseUrl}/patients/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const transferPatient = (
  patientId: any,
  fromCenterId: any,
  toCenterId: any
) => {
  return apiHelper
    .patch(
      `${adminServiceBaseUrl}/patients/${patientId}/center/${fromCenterId}/transfer/${toCenterId}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getTaxCatalogDetails = (centerId: any): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/centers/tax/${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const addNewTax = (centerId: any, taxInfo: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/centers/tax/${centerId}`, taxInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const deleteCatalogTax = (id: string, centerId: any): Promise<any> => {
  return apiHelper
    .delete(`${masterServiceBaseUrl}/centers/tax/${centerId}/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const getPaymentModeDetails = (centerId: any): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/centers/payment-methods/${centerId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const addNewPayment = (centerId: any, taxInfo: any): Promise<any> => {
  return apiHelper
    .post(
      `${masterServiceBaseUrl}/centers/payment-methods/${centerId}`,
      taxInfo
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const deletePayment = (id: string, centerId: any): Promise<any> => {
  return apiHelper
    .delete(`${masterServiceBaseUrl}/centers/payment-methods/${centerId}/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const addNewAvailability = (availabilityInfo: any): Promise<any> => {
  return apiHelper
    .post(`${resourceServiceBaseUrl}/availability`, availabilityInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const updateAvailability = (availabilityInfo: any): Promise<any> => {
  const id = availabilityInfo?.id
  delete availabilityInfo?.id
  return apiHelper
    .put(`${resourceServiceBaseUrl}/availability/${id}`, availabilityInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const getAvailabilityDetails = (
  centerId: any,
  consultantId: any
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/availability?centerId=${centerId}&consultantId=${consultantId}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getFormsAndTemplates = (): Promise<any> => {
  return apiHelper
    .get(masterServiceBaseUrl + `/form-templates/type?type=CONSENT`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getPrescriptions = (): Promise<any> => {
  return apiHelper
    .get(masterServiceBaseUrl + `/drugs`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const verifyUser = (token: any): Promise<any> => {
  return apiUnauthenticatedHelper
    .post(`${userServiceBaseUrl}/staff/verify-email`, token, {})
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const addPaytmMerchant = (paytmMerchantInfo: any): Promise<any> => {
  return apiHelper
    .post(`${resourceServiceBaseUrl}/paytm/merchant`, paytmMerchantInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updatePaytmMerchant = (id: any, paytmMerchantInfo: any): Promise<any> => {
  return apiHelper
    .put(`${resourceServiceBaseUrl}/paytm/merchant/${id}`, paytmMerchantInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getAllPaytmMerchants = (): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/paytm/merchants`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getManagePaytmMerchantById = (id: string): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/paytm/merchant/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllPaytmTerminalsById = (id: string): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/paytm/terminals/center-paytm-merchant/${id}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const addPaytmTerminal = (paytmTerminalInfo: any): Promise<any> => {
  return apiHelper
    .post(`${resourceServiceBaseUrl}/paytm/terminal`, paytmTerminalInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updatePaytmTerminal = (id: any, paytmTerminalInfo: any): Promise<any> => {
  return apiHelper
    .put(`${resourceServiceBaseUrl}/paytm/terminal/${id}`, paytmTerminalInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getAllPaytmTerminalsByCenterId = (
  centerId: string,
  appointmentType: String | null = null
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/paytm/terminals/center/${centerId}?appointmentType=${appointmentType}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const intitiatePaytmPayment = (
  centerId: string,
  paytmTerminalId: string,
  paymentInfo: any
): Promise<any> => {
  return apiHelper
    .post(
      `${resourceServiceBaseUrl}/paytm/${centerId}/initiate-payment/${paytmTerminalId}`,
      paymentInfo
    )
    .then((res) => {
      return res
    })
    .catch((err) => Promise.reject(err))
}

const checkPaytmPaymentStatus = (
  paymentTransactionId: string,
  paymentType: string | null = null
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/paytm/check-payment-status/${paymentTransactionId}${paymentType ? `?paymentType=${paymentType}` : ""
      }`
    )
    .then((res) => {
      return res
    })
    .catch((err) => Promise.reject(err))
}

const getWondersoftDrugs = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/wondersoft/drugs`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getDrugById = (id: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/wondersoft/get-drug/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const updateDrugInfo = (id: any, drugInfo: any): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/wondersoft/update-drug/${id}`, drugInfo)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const syncDrugs = (): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/wondersoft/sync-drugs`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export {
  getAllConsultantReferralDetails,
  deleteConsultantDetail,
  addNewReferralDoctor,
  getConsultantReferralDetailsById,
  getAllManageStaffDetails,
  updateContactReferrals,
  addNewBed,
  updateBedManagement,
  getBedManagementDetailsById,
  deleteBedDetail,
  getAllManageStaffDetailsByCenter,
  addManageStaff,
  getManageStaffDetailsById,
  updateManageStaff,
  deleteManageStaff,
  getDuplicatePatients,
  getDuplicatePatientView,
  getAllStaffRoles,
  transferPatient,
  getTaxCatalogDetails,
  addNewTax,
  deleteCatalogTax,
  getPaymentModeDetails,
  addNewPayment,
  deletePayment,
  getAvailabilityDetails,
  addNewAvailability,
  updateAvailability,
  getCenterDetails,
  addNewServices,
  getPrescriptions,
  getFormsAndTemplates,
  getConsultantServiceDetailsById,
  updateServices,
  deleteConsultantServiceDetail,
  getAllConsultantServicesDetails,
  updateNewServices,
  verifyUser,
  addMasterNewServices,
  getAllMasterServicesDetails,
  addNewMasterServices,
  copyServices,
  getRateCardByServiceId,
  updateMasterServices,
  getAllManageStaffDetailsByCenterId,
  getServicesNotInCenter,
  getMinimalRegisterCenter,
  getServiceDetailByServiceId,
  getServicesBasedOnCenterId,
  getAllPaytmMerchants,
  getManagePaytmMerchantById,
  addPaytmMerchant,
  updatePaytmMerchant,
  getAllPaytmTerminalsById,
  addPaytmTerminal,
  updatePaytmTerminal,
  getAllPaytmTerminalsByCenterId,
  intitiatePaytmPayment,
  checkPaytmPaymentStatus,
  getWondersoftDrugs,
  getDrugById,
  updateDrugInfo,
  syncDrugs,
}
